module.exports = __webpack_public_path__ + "img/homeuser.2887c80e.png";